// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3Ets4","colMin":"styles_colMin__LN38S","colCheckbox":"styles_colCheckbox__28o-Z"};